import { render, staticRenderFns } from "./blogList.vue?vue&type=template&id=55efa70a"
import script from "./blogList.vue?vue&type=script&lang=js"
export * from "./blogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports